import ReactSelectFormatter from '../services/ReactSelectFormatter';
import DateHelper, {DATE_TIME_FORMAT} from '../components/helpers/DateHelper';
import moment from 'moment';


class ArticleParamsFormatter {
    static format(article) {
        let categoryIds = article.categoryIds === undefined ? [] : article.categoryIds;
        return {
            id: article.id,
            heading: article.heading,
            contactPersonId: article.contactPersonId,
            categories: ReactSelectFormatter.getIds(categoryIds),
            templateId: article.templateId,
            publishAt: this.getUnixStamp(article.publishAt),
            isCommentsAllowed: article.isCommentsAllowed,
            authoredByFBG: article.authoredByFBG,
            description: article.description,
            resume: article.resume
        };
    }

    static convertToForm(article) {
        let formattedArticle = Object.assign({}, article);
        if(formattedArticle.images instanceof Object) {
            if(!(formattedArticle.images instanceof Array)) {
                formattedArticle.images = Object.values(formattedArticle.images);
            }

            formattedArticle.defaultImages = formattedArticle.images;
            formattedArticle.defaultImageIds = formattedArticle.defaultImages.map(image => image.id);
        }
        else {
            formattedArticle.images = formattedArticle.defaultImages = formattedArticle.defaultImageIds = [];
        }

        if(formattedArticle.files instanceof Object) {
            if(!(formattedArticle.files instanceof Array)) {
                formattedArticle.files = Object.values(formattedArticle.files);
            }

            formattedArticle.defaultFiles = formattedArticle.files;
            formattedArticle.defaultFileIds = formattedArticle.defaultFiles.map(file => file.id);
        }
        else {
            formattedArticle.files = formattedArticle.defaultFiles = formattedArticle.defaultFileIds = [];
        }

        return {
            id: formattedArticle.id,
            contactPersonId: formattedArticle.contactPerson ? formattedArticle.contactPerson.id : null,
            isCommentsAllowed: formattedArticle.isCommentsAllowed,
            heading: formattedArticle.heading,
            templateId: formattedArticle.template.id,
            description: formattedArticle.description,
            categoryIds: ReactSelectFormatter.format(formattedArticle.categories),
            publishAt: moment.unix(formattedArticle.publishAt).format(DATE_TIME_FORMAT),
            authoredByFBG: formattedArticle.authoredByFBG,
            sentOutAt: (formattedArticle.sentOutAt > 0) ? moment.unix(formattedArticle.sentOutAt).format(DATE_TIME_FORMAT) : '',
            resume: formattedArticle.resume,
            defaultImageIds: formattedArticle.defaultImageIds,
            defaultImages: formattedArticle.defaultImages,
            images: [],
            defaultFileIds: formattedArticle.defaultFileIds,
            defaultFiles: formattedArticle.defaultFiles,
            youtubeId: formattedArticle.youtubeId || '',
            vimeoId: formattedArticle.vimeoId || '',
            files: [],
            oldCategories: formattedArticle.oldCategories.map(c => { return {value: c.id, label: c.name, } }),
        };
    }

    /**
     *
     * @param {string} dateString
     * @returns {integer}
     */
    static getUnixStamp(dateString) {
        let dateObject = moment(dateString, DATE_TIME_FORMAT);
        return DateHelper.getUnixTimestampByTimezone(dateObject);
    }
}

export default ArticleParamsFormatter;


// WEBPACK FOOTER //
// ./web/src/services/ArticleParamsFormatter.js